import { PlaidConnectionStatus, UserType } from '../../types';
import { apiError } from '../../utils/errors';

interface ExchangeTokenArgs {
  publicToken: string;
  institutionName: string;
  accountCount: number;
  questionName: string;
}

const REQUEST_TIMEOUT_MS = 30_000;

export const exchangeToken = async (
  urlSlug: string,
  publicId: string,
  args: ExchangeTokenArgs,
  userType: UserType,
): Promise<PlaidConnectionStatus> => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);

  try {
    const isSigner = userType === UserType.SIGNER;
    const response = await fetch(`${process.env.REACT_APP_API_URL}/submissions/${urlSlug}/${publicId}/plaid/exchange?isSigner=${isSigner}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        public_token: args.publicToken,
        institutionName: args.institutionName,
        accountCount: args.accountCount,
        questionName: args.questionName,
      }),
      credentials: 'include',
      signal: controller.signal,
    });

    if (!response.ok) {
      const errorJson = await response.json().catch(() => ({}));
      throw apiError(response.status, errorJson?.message || 'Failed to exchange Plaid token', errorJson?.code);
    }

    const responseJson = await response.json();
    return responseJson.data;
  } finally {
    clearTimeout(timeout);
  }
};
